<script setup>
const emit = defineEmits(['select']);

const reactions = [
  { type: 'like', label: 'Like', emoji: '👍', color: 'text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-950/30' },
  { type: 'love', label: 'Love', emoji: '❤️', color: 'text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/30' },
  { type: 'care', label: 'Care', emoji: '🥰', color: 'text-amber-500 hover:bg-amber-50 dark:hover:bg-amber-950/30' },
  { type: 'haha', label: 'Haha', emoji: '😆', color: 'text-yellow-500 hover:bg-yellow-50 dark:hover:bg-yellow-950/30' },
  { type: 'wow', label: 'Wow', emoji: '😮', color: 'text-yellow-500 hover:bg-yellow-50 dark:hover:bg-yellow-950/30' },
  { type: 'sad', label: 'Sad', emoji: '😢', color: 'text-sky-500 hover:bg-sky-50 dark:hover:bg-sky-950/30' },
  { type: 'angry', label: 'Angry', emoji: '😡', color: 'text-red-500 hover:bg-red-50 dark:hover:bg-red-950/30' },
];

const selectReaction = (type) => {
  emit('select', type);
};
</script>

<template>
  <div class="flex items-center gap-0.5 sm:gap-1 bg-base-100/95 backdrop-blur-md p-1 sm:p-1.5 rounded-full shadow-2xl border border-base-200/90 animate-pop-in max-w-[calc(100vw-2rem)] overflow-x-auto no-scrollbar">
    <button
      v-for="item in reactions"
      :key="item.type"
      type="button"
      :title="item.label"
      class="group relative flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 rounded-full transition-all duration-200 hover:scale-130 hover:-translate-y-1 active:scale-95 shrink-0"
      :class="item.color"
      @click.stop="selectReaction(item.type)"
    >
      <span class="text-lg sm:text-xl select-none transform transition-transform group-hover:rotate-6">{{ item.emoji }}</span>
      <span class="absolute -top-7 scale-0 group-hover:scale-100 transition-all duration-150 text-[10px] font-bold bg-neutral text-neutral-content px-2 py-0.5 rounded-full shadow-md pointer-events-none whitespace-nowrap hidden sm:inline-block">
        {{ item.label }}
      </span>
    </button>
  </div>
</template>

<style scoped>
@keyframes popIn {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.92);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.animate-pop-in {
  animation: popIn 0.2s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
